import GenericRowEditAndDeleteModal from 'components/icons/GenericRowEditAndDeleteModal';

export const columnsDataForcaVenda = [
	{
		Header: ' ',
		accessor: 'CheckBox',
		disableSortBy: true,
		type: 'checkBox',
		filter: false,
	},
	{
		Header: 'Força de Venda',
		accessor: 'nome_forca_venda',
		type: 'text',
		optional: true,
		filter: 'includesIgnoreCase',
		hover: 'Nome da força de venda',
	},
	{
		Header: ' ',
		type: 'jsx',
		accessor: 'button',
		jsx: GenericRowEditAndDeleteModal,
		filter: false,
	},
];
